export const styles = {
  COLUMNS : { 
    MAX_COLUMN_WIDTH: 50,
    MIN_COLUMN_WIDTH: 25,
    totalColumns: 12,
  },
  ROWS: {
    HEADER_ROW_HEIGHT: 48
  },
  emptyColumnIndex: [11],
  LITERALS: {
    EMPTY: ' ',
    DASH : '-'
  },
  FILL: {
    SOLID_FILL: 'solid',
  },
  BORDER: {
    THICK_BORDER_WIDTH: 'thick',
    THIN_BORDER_WIDTH: 'thin'
  },
  ALIGNMENT: {
    LEFT_ALIGNMENT: 'left',
    MIDDLE_ALIGNMENT: 'middle',
    RIGHT_ALIGNMENT: 'right',
    CENTER_ALIGNMENT: 'center',
  },
  COLORS: {
    HEADER_CELL_FONT_COLOR: 'FFFFFF',
    CELL_BGCOLOR: '3DCD58',
    CELL_FONT_COLOR: '676767',
    GROUP_FONT_COLOR: '333333',
    GROUP_HEADER_BGCOLOR: 'E6E6E6',
    GROUP_BGCOLOR: 'EDEDED',
    SUBTOTAL_BGCOLOR: '626469',
    SUBSTITUTION_ROW_BGCOLOR: 'EBFAEE',
    DEFAULT_ROW_HEIGHT: 48,
  },
  INDENT:  {
    RTL: 5,
    LTR: 2
  },
  EXCEL_ROW_START:  {
    RTL: 2
  },
  INCREMENT:  {
    RTL: 1,
    LTR: -1
  },
  CELL_TYPE: 'pattern',
}

export const columnsConfig = [
  { key: 'excelPartNumber', hidden: false , width: styles.COLUMNS.MAX_COLUMN_WIDTH, hideIfEmpty: false},
  { key: 'giftlistTableQty', hidden: false, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: false },
  { key: 'excelEntityType', hidden: true, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true},
  { key: 'excelConfigurationId', hidden: true, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: false},
  { key: 'excelProductCode', hidden: false, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true},
  { key: ' ', hidden: false , width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true},
  { key: 'excelShortDescription', hidden: false, width: styles.COLUMNS.MAX_COLUMN_WIDTH, hideIfEmpty: false },
  { key: 'excelShipping', hidden: true,width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true },
  { key: 'excelPrice', hidden: false, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true },
  { key: 'excelCurrency', hidden: false, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true },
  { key: 'giftlistTableSubtotal', hidden: false, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true },
  { key: ' ', hidden: true, width: styles.COLUMNS.MIN_COLUMN_WIDTH, hideIfEmpty: true },
];

export const LOCAL_DISTRIBUTOR_INDEX = 5; // zero-based
export const columnsDefaultValues = [
  'Part Number',
  'Quantity',
  'Entity Type',
  'Configuration Id',
  'Product Code',
  ' ',
  'Short Description',
  'Shipping Days',
  'Price',
  'Currency',
  'Subtotal',
  ' '
];
export const TOTAL_LABEL = 'Total'; 

export enum MPC_ROW_TYPE {
  GROUP_PRODUCT = 'group',
  SINGLE_PRODUCT = 'single',
  SUBSTITUTION_RANGE = 'range',
  SUBSTITUTION_PRODUCT = 'product',
  NOT_AVAIABLE = 'N/A',
  DEFAULT = 'Single Item',
  BOM_PRODUCT = 'BOM',
  CONFIGURATION = 'configuration',
  CTO_CONFIGURATION = 'CTO Configuration',
}


